import { render, staticRenderFns } from "./insertAttributeValue.vue?vue&type=template&id=038a5619&scoped=true"
import script from "./insertAttributeValue.vue?vue&type=script&lang=js"
export * from "./insertAttributeValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038a5619",
  null
  
)

export default component.exports